import { useQuery } from '@tanstack/react-query';
import { appointmentsService } from '../services/appointmentsService.service';
import { Appointment } from '../adapters/appointmentAdapter';

export const usePrivateAppointments = (location: string) => {
  return useQuery<Appointment[]>({
    queryKey: ['privateAppointments', location],
    queryFn: () => appointmentsService.getPrivateAppointments(location),
    enabled: !!location
  });
};
